import React, { useEffect, useState } from "react";
import "./index.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Col, Input, Row, Select, Space } from "antd";
import FileItem from "components/molecules/FileItem";

const { Search } = Input;
const { Option } = Select;
const FileList = (props) => {
  const [listValues, setListValues] = useState([]);
  const [initialValues, setInitialValues] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    setListValues(props.files);
    setInitialValues(props.files);
  }, [props.files]);

  return (
    <>
      <Row justify="space-between" className="filtre-page">
        <Col>
          <Search
            placeholder={t("Rechercher par mots clés")}
            className="search-files-input"
            onChange={(value) => {
              setListValues(
                initialValues.filter(
                  ({ title, fileName }) =>
                    title.includes(value.target.value) ||
                    fileName.includes(value.target.value)
                )
              );
            }}
          />
        </Col>
        <Col>
          <Space>
            <Select
              placeholder={t("Choisir l'année :")}
              onChange={(value) => {
                if (value !== "") {
                  setListValues(
                    initialValues.filter(({ year }) => year === value)
                  );
                } else {
                  setListValues(initialValues);
                }
              }}
            >
              <Option value="">{t("Toutes les années :")} </Option>
              <Option value="2021">2021</Option>
              <Option value="2020">2020</Option>
              <Option value="2019">2019</Option>
              <Option value="2018">2018</Option>
              <Option value="2017">2017</Option>
              <Option value="2016">2016</Option>
              <Option value="2015">2015</Option>
              <Option value="2014">2014</Option>
              <Option value="2013">2013</Option>
              <Option value="2012">2012</Option>
              <Option value="2011">2011</Option>
              <Option value="2010">2010</Option>
            </Select>
          </Space>
        </Col>
      </Row>
      <Row justify="start" className="actualites-section-content">
        {listValues &&
          listValues.map((item, index) => (
            <FileItem file={item} key={index}></FileItem>
          ))}
      </Row>
    </>
  );
};

FileList.propTypes = {
  files: PropTypes.array,
};

export default FileList;
